export default "__VITE_ASSET__B_lJX7YD__"